import client from '@stores/apollo'
import gql from 'graphql-tag'
import { AssignmentPlanFragment } from '@api/fragments'
import { IAssignmentPlan } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

export interface CloneAssignmentPlanMutationInput {
  id: string
}

interface IPayload {
  cloneAssignmentPlan: {
    assignmentPlan: IAssignmentPlan
  }
}

const mutateHandler = handleFetchResult<IPayload, IAssignmentPlan>({
  handler: (data) => data.cloneAssignmentPlan.assignmentPlan,
  name: 'Assignment Plan',
})

export default function clone(input: CloneAssignmentPlanMutationInput): Promise<IAssignmentPlan> {
  return client.gql.mutate<IPayload>({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation CloneAssignmentPlan($input: CloneAssignmentPlanMutationInput!) {
    cloneAssignmentPlan(input: $input) {
      assignmentPlan {
        ...AssignmentPlanFragment
      }
    }
  }
  ${AssignmentPlanFragment}
`
